<template>
  <div class="google_tasks">
      <table class="google_tasks__tasks" v-if="tasks.length !== 0">
          <tr v-for="task in tasks" :key="task.id">
              <td style="width:10%;font-size:20px;"><input type="checkbox" @change="toggleTask(task)" :checked="task.status === 'completed'"></td>
              <td>{{ task.title }}</td>
          </tr>
      </table>
      <div v-if="tasks.length === 0">
          <p>No open tasks in this list.</p>
      </div>
      <select class="google_tasks__select_tasklist" @change="getTasks" v-model="current_tasklist_id">
          <option v-for="list in tasklists" :key="list.id" :value="list.id">{{ list.title }}</option>
      </select>
  </div>
</template>

<script>
import OAuth from "../../../lib/oauth";

export default {
    name: "Tasks",
    props: {
        id: {
            type: Number,
            required: true
        }
    },
    data () {
        return {
            // Services
            oauth_service: undefined,

            // Content
            tasklists: [],
            tasks: [],
            
            // Other parameters
            current_tasklist_id: ""
        }
    },
    mounted() {
        this.oauth_service = new OAuth(this.id, "oauth");

        this.getTaskLists().then(this.getTasks);
    },
    methods: {
        getTaskLists() {
            return new Promise(async function(resolve) {
                var response = await this.oauth_service.request("https://www.googleapis.com/tasks/v1/users/@me/lists", "GET");
            
                if (response.status === 200) {
                    this.tasklists = response.data.items;
                    this.current_tasklist_id = response.data.items[0].id;
                }
                resolve(true);
            }.bind(this));
        },
        async getTasks() {
            var response = await this.oauth_service.request("https://www.googleapis.com/tasks/v1/lists/" + this.current_tasklist_id + "/tasks?showCompleted=false", "GET");

            if (response.status === 200) {
                this.tasks = response.data.items;
            } else {
                this.tasks = [];
            }

            this.$emit("loaded");
        },
        async toggleTask(task) {
            if (task.status === "completed") {
                task.status = "needsAction";
            } else {
                task.status = "completed"
            }

            var response = await this.oauth_service.request("https://www.googleapis.com/tasks/v1/lists/" + this.current_tasklist_id + "/tasks/" + task.id, "PUT", task);

            if (response.status === 200) {
                this.getTasks();
            }
        }
    }
}
</script>

<style>
.google_tasks__tasks {
    text-align: left;
    width: 100%;
}

.google_tasks__tasks tr {
    padding: 5px 0 5px 0;
}

.google_tasks__tasks td {
    text-align: left;
}
</style>